import {
  Col,
  Row,
  Modal,
  Form,
  Button,
  Input,
  Switch,
} from "antd";
import Title from "../UI/Title/Title";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import "../UI/AddButton/add.css";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";

type propsType = {
  isopenScan: boolean;
  setIsOpenScan: React.Dispatch<React.SetStateAction<boolean>>;
};
export const ScanReturn = ({ isopenScan, setIsOpenScan }: propsType) => {
  const { TextArea } = Input;
  const [quantity, setQuantity] = useState(1);

  const handleIncrement = () => {
    setQuantity(quantity + 1);
  };
  const handleDecrement = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };
  const [t] = useTranslation("common");

  const [form] = Form.useForm();
  const [inputEnabled, setInputEnabled] = useState(false);
  const TaxableChange = (checked: any) => {
    setInputEnabled(checked);
  };

  return (
    <Modal
      closable={false}
      maskClosable={false}
      width={950}
      centered
      onCancel={() => setIsOpenScan(false)}
      open={isopenScan}
      footer={null}
    >
      <Form layout="vertical" form={form}>
        <Row gutter={[0, 10]}>
          <Col offset={1} span={14}>
            <Title title={`${t("add-items-to-returns")}`} />
          </Col>
          <Col>
            {" "}
            <span className="colcolor"> {t("F9")}&nbsp; </span>{" "}
            <span className="spancolor"> {t("save & add")}&nbsp; </span>{" "}
            <span className="colcolor"> {t("F10")} </span> &nbsp;{" "}
            <span className="spancolor"> {t("save & close")} </span>&nbsp;{" "}
            <span className="colcolor"> {t("Esc")} </span>&nbsp;{" "}
            <span className="spancolor"> {t("cancel")} </span>&nbsp;{" "}
          </Col>
          <Col offset={1} span={22} className="modaltitleEdit">
            {t("item-name-details")}
          </Col>

          <Col offset={1} span={8}>
            <Form.Item name="barcode" label={`${t("barcode")}`}>
              <Input
                placeholder={`${t("enter-text")}`}
                data-testid="barcode"
                autoComplete="off"
              />
            </Form.Item>

            <Form.Item
              name="price"
              label={`${t("price")}`}
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input
                autoComplete="off"
                placeholder={`${t("enter-text")}`}
                data-testid="price"
              />
            </Form.Item>

            <Form.Item name="quantity" label={`${t("original-quantity")}`}>
              <Row gutter={5} align="middle">
                <Col>
                  <Button
                    className="addbutton"
                    icon={<MinusOutlined />}
                    size={"small"}
                    onClick={handleDecrement}
                  />
                </Col>
                <Col span={4}>
                  <Input value={quantity} autoComplete="off" />
                </Col>
                <Col span={6}>
                  <Button
                    className="addbutton"
                    icon={<PlusOutlined />}
                    size={"small"}
                    onClick={handleIncrement}
                  />
                </Col>
              </Row>
            </Form.Item>

            <Form.Item name="quantity" label={`${t("return-quantity")}`}>
              <Row gutter={5} align="middle">
                <Col>
                  <Button
                    className="addbutton"
                    icon={<MinusOutlined />}
                    size={"small"}
                    onClick={handleDecrement}
                  />
                </Col>
                <Col span={4}>
                  <Input value={quantity} autoComplete="off" />
                </Col>
                <Col span={6}>
                  <Button
                    className="addbutton"
                    icon={<PlusOutlined />}
                    size={"small"}
                    onClick={handleIncrement}
                  />
                </Col>
              </Row>
            </Form.Item>
          </Col>
          <Col offset={2} span={9} >

            <Form.Item
              name="taxable"
              label={`${t("taxable")}`}
              rules={[
                {
                  required: inputEnabled,
                },
              ]}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "5px",
                }}
              >
                <Switch
                  checkedChildren={`${t("yes")}`}
                  unCheckedChildren={`${t("no")}`}
                  onChange={TaxableChange}
                />
              </div>
              <div>
                <Form.Item name="tax" style={{ marginTop: "45px" }}>
                  <Input
                    autoComplete="off"
                    placeholder="Enter tax"
                    data-testid="taxable"
                    disabled={!inputEnabled}
                  />
                </Form.Item>
              </div>
            </Form.Item>

            <Form.Item name="notes" label={`${t("notes")}`}>
              <TextArea
                autoComplete="off"
                className="scrollable-textarea"
                data-testid="description-input"
                placeholder={`${t("enter-text")}`}
                autoSize={{ minRows: 4, maxRows: 4 }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row style={{ marginTop: "20px" }}>
          <Col offset={1}>
            <Button
              size="large"
              style={{
                color: "#1677FF",
                border: "1px solid #1677FF",
                width: "110px",
              }}
              onClick={() => {
                setIsOpenScan(false);
              }}
            >
              {t("cancel")}
            </Button>
          </Col>
          <Col offset={12}>
            {" "}
            <Button
              style={{
                width: "115px",
                background: "#1677FF",
                color: "#fff",
                border: "none",
              }}
              size="large"
              onClick={() => { setIsOpenScan(false); }}
            >
              {t("save-&-close")}
            </Button>
          </Col>
          <Col offset={1}>
            <Button
              style={{
                width: "110px",
                background: "#1677FF",
                color: "#fff",
                border: "none",
              }}
              size="large"
            >
              {t("save-&-add")}
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};
